import React, { FC } from 'react';
import styled from 'styled-components';
import InstagramIcon from '@westwing/ui-kit/Icons/InstagramIcon';
import PinterestIcon from '@westwing/ui-kit/Icons/PinterestIcon';
import YoutubeIcon from '@westwing/ui-kit/Icons/YoutubeIcon';
import FacebookIcon from '@westwing/ui-kit/Icons/FacebookIcon';
import useTranslator from '../../hooks/useTranslator';
import { StyledWrapper, StyledLinkWrapper } from './IconTray';

const StyledYoutubeLinkWrapper = styled(StyledLinkWrapper)`
    height: 16px;
    width: 20px;
`;

const StyledPinterestLinkWrapper = styled(StyledLinkWrapper)`
    height: 18px;
    width: 14px;
`;

interface SocialMediaProps {
    instagramLink: string;
    pinterestLink: string;
    youtubeLink: string;
    facebookLink: string;
}

const SocialMedia: FC<SocialMediaProps> = ({ instagramLink, youtubeLink, pinterestLink, facebookLink }) => {
    const t = useTranslator();
    return (
        <StyledWrapper>
            {instagramLink && (
                <StyledLinkWrapper href={instagramLink} title={t('Instagram social title')}>
                    <InstagramIcon />
                </StyledLinkWrapper>
            )}
            {pinterestLink && (
                <StyledPinterestLinkWrapper href={pinterestLink} title={t('Pinterest social title')}>
                    <PinterestIcon />
                </StyledPinterestLinkWrapper>
            )}
            {youtubeLink && (
                <StyledYoutubeLinkWrapper href={youtubeLink} title={t('Youtube social title')}>
                    <YoutubeIcon />
                </StyledYoutubeLinkWrapper>
            )}
            {facebookLink && (
                <StyledLinkWrapper href={facebookLink} title={t('Pinterest social title')}>
                    <FacebookIcon />
                </StyledLinkWrapper>
            )}
        </StyledWrapper>
    );
};

export default SocialMedia;
